var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 256.00003 256.00002",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1"
  }, "\r\n\t.st0{fill:none;stroke:#0074D6;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#51B0B0;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#A4C53E;stroke-miterlimit:10;}\r\n\t.st3{fill:#FF0000;}\r\n\t.st4{fill:#FFFF00;}\r\n\t.st5{fill:none;stroke:#FF0000;stroke-miterlimit:10;}\r\n\t.st6{fill:#FCFC03;}\r\n")), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      stroke: "#fcfc03",
      strokeWidth: 7.75758,
      strokeOpacity: 1
    },
    id: "path2",
    cx: 128.00002,
    cy: 128.00002,
    r: 124.12122
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "translate(20.500013,20.500013)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "158.2,114.2 140.4,168.9 170.1,154.2 180.7,121.4 160.8,106.8 161,106.4 190.3,91.8 200.4,60.8 180.2,46.1 45.7,46.1 14.6,69.2 172.7,69.2 164.3,95.2 100.9,95.2 94.8,114.2 ",
    id: "polygon1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "140.4,168.9 148,145.4 59.3,145.4 77.6,88.4 57.3,73.2 26.8,168.9 ",
    id: "polygon2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlast);
export default __webpack_public_path__ + "static/media/blast.658c08d2e20d230198f1a1ef5fc625a9.svg";
export { ForwardRef as ReactComponent };